export type WikiId = 'dossier' | 'guidelines';

export interface WikiDef {
  id: WikiId;
  labelKey: string;
  labelFallback: string;
  overview: string;
  // Absent when the wiki has no page catalog distinct from its overview.
  index?: string;
}

export const WIKIS: WikiDef[] = [
  {
    id: 'dossier',
    labelKey: 'esc.wiki.this_policy',
    labelFallback: 'This policy',
    overview: 'overview.md',
    index: 'index.md',
  },
  {
    id: 'guidelines',
    labelKey: 'esc.wiki.guidelines',
    labelFallback: 'Guidelines',
    overview: 'knowledge/overview.md',
  },
];

export function resolveWikis(
  hasGuidelines: boolean | undefined | null
): WikiDef[] {
  return hasGuidelines === true
    ? WIKIS
    : WIKIS.filter((w) => w.id !== 'guidelines');
}
